module.exports = __webpack_public_path__ + "img/Jasper - Open Arms.65f0f438.png";